/* eslint-disable
    eqeqeq,
    */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import { Analytics } from '@trello/atlassian-analytics';

import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
import { View } from 'app/scripts/views/internal/View';

const t = teacupWithHelpers();

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @trello/no-module-logic
const template = t.renderable(function ({ icon, name, text, type }: any) {
  if (icon != null) {
    t.icon(icon, { class: 'mod-quiet' });
  }
  return t.span('.badge-text', function () {
    if (name && type !== 'checkbox') {
      return t.text(`${name}: ${text}`);
    } else {
      return t.text(text);
    }
  });
});

const colorClasses = {
  black: 'field-color-black',
  blue: 'field-color-blue',
  green: 'field-color-green',
  orange: 'field-color-orange',
  red: 'field-color-red',
  yellow: 'field-color-yellow',
  purple: 'field-color-purple',
  pink: 'field-color-pink',
  sky: 'field-color-sky',
  lime: 'field-color-lime',
  'light-gray': 'field-color-light-gray',
};

interface CustomFieldBadgeView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customField: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customFieldItem: any;
}

class CustomFieldBadgeView extends View {
  static initClass() {
    this.prototype.tagName = 'div';
  }
  className() {
    // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const colorClasses = this.getColorClasses(' ');
    if (colorClasses) {
      return `badge field-color ${colorClasses.join(' ')}`;
    }
    return 'badge';
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialize({ customFieldItem, customField }: any) {
    this.customFieldItem = customFieldItem;
    this.customField = customField;
  }

  getColorClasses() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const color = this.options.customFieldItem?.getColor();
    if (!color || color === 'none') {
      return '';
    }
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return [colorClasses[color], `color-blind-pattern-${color}`];
  }

  trackCustomFieldValueUpdate() {
    Analytics.sendTrackEvent({
      action: 'updated',
      actionSubject: 'customFieldValue',
      source: 'cardDetailBadge',
      attributes: {
        type: this.customField.get('type'),
      },
      containers: this.customField.getBoard().getAnalyticsContainers(),
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderBadge(badge: any) {
    this.$el.html(template(badge));
    return this.$el;
  }

  render() {
    const customField = this.customField.toJSON();
    const customFieldItem = this.customFieldItem.toJSON();

    const icon =
      this.customField.get('type') === 'checkbox'
        ? this.customField.icon()
        : undefined;
    const text = this.customFieldItem.getFrontBadgeText();

    this.renderBadge({
      ...customFieldItem,
      ..._.pick(customField, 'name', 'type'),
      icon,
      text,
    });

    return this;
  }
}

CustomFieldBadgeView.initClass();
export { CustomFieldBadgeView };
